import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Box } from "@mui/material";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import { postData } from "src/views/utilities/api";
import { useSelector } from "react-redux";
import Loader from "src/components/Loader";

function History({ open, onClose, getBillToUpdate }) {
  const [loading, setLoading] = useState(false);
  const headerData = useSelector((state) => state.quotationMaster);

  const [allBills, setAllBills] = useState([]);

  useEffect(() => {
    const getHistoryBill = async () => {
      if (headerData.party?.label) {
        try {
          setLoading(true);
          const getHistory = await postData("/api/getOrderHistory", {
            PartyName: headerData.party?.label,
            type:"qoutation"
          });

          if (getHistory.success) {
            setAllBills(getHistory.data);
          }
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      }
    };
    if (open) getHistoryBill();
  }, [headerData.party, open]);

  const columns = [
    { field: "billNo", headerName: "Bill No", width: 150, flex: 1 },
    { field: "party", headerName: "Party", width: 150, flex: 1 },
    { field: "netTotal", headerName: "Bill Amount", width: 150, flex: 1 },
    { field: "receiptAmt", headerName: "Receipt", width: 150, flex: 1 },
    { field: "balance", headerName: "Balance", width: 150, flex: 1 },
    {
      field: "action",
      headerName: "Action",

      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleGetBill(params.row.billNo)}
        >
          Get
        </Button>
      ),
      sortable: false,
      filterable: false,
    },
  ];

  const handleGetBill = (billNo) => {
    if (billNo) {
      getBillToUpdate(billNo);
      onClose();
    } else {
      alert("Bill no not found");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Loader start={loading} />
      <DialogTitle>History</DialogTitle>
      <DialogContent>
        <Box sx={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={allBills.map((row, index) => ({ id: index, ...row }))}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default History;

History.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  getBillToUpdate: PropTypes.func,
};
